import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import CardProgramForm from './CardProgramForm';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import WizardCard from 'react/signups/card/common/WizardCard';
import cardProgramDataShape from 'react/signups/card/shapes/CardProgramData';
import cardProgramQuestionsShape from 'react/signups/card/shapes/CardProgramQuestions';

export default function CardProgram({
  cardProgramData,
  cardProgramQuestions,
  firstName,
  moduleComplete,
  setCardProgramData,
}) {
  // If we are funded by trust, we want to only validate the atm step if they selected no to that question
  const atmAccessValidation = cardProgramQuestions.funded_from_trust
    ? {
        atmAccess: Yup.string().when('fundedByTrust', {
          is: 'no',
          then: () => Yup.string().required('Please select one of the options'),
        }),
      }
    : {
        atmAccess: Yup.string().required('Please select one of the options'),
      };
  const validationSchema = Yup.object().shape({
    ...(cardProgramQuestions.atm_access ? atmAccessValidation : {}),
    ...(cardProgramQuestions.funded_from_trust
      ? { fundedByTrust: Yup.string().required('Please select one of the options') }
      : {}),
  });

  const handleContinue = (values) => {
    setCardProgramData({
      fundedByTrust: values.fundedByTrust,
      atmAccess:
        !cardProgramQuestions.funded_from_trust || values.fundedByTrust === 'no'
          ? values.atmAccess
          : '',
    });
  };

  return (
    <WizardCard>
      <Formik
        initialValues={cardProgramData}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleSubmit, values, handleChange }) => (
          <>
            <CardProgramForm
              cardProgramQuestions={cardProgramQuestions}
              firstName={firstName}
              onChange={handleChange}
              values={values}
            />
            <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

CardProgram.propTypes = {
  cardProgramData: cardProgramDataShape.isRequired,
  cardProgramQuestions: cardProgramQuestionsShape.isRequired,
  firstName: PropTypes.string.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  setCardProgramData: PropTypes.func.isRequired,
};
